const PRODUCT_ATTRIBUTE_SILHOUETTE = 'SIL';
const PRODUCT_ATTRIBUTE_DIVISION = 'DIV';
const FOOTWEAR_ATTRIBUTE_VALUE = '20';
const FOOTWEAR_DIVISION_VALUE = 'FTWR';
const APPAREL_ATTRIBUTE_VALUE = '10';
const APPAREL_DIVISION_VALUE = 'APRL';
const EQUIPMENT_ATTRIBUTE_VALUE = '30';
const EQUIPMENT_DIVISION_VALUE = 'EQMT';

export const hasAllotmentsOrOptions = (list, product) =>
  list.some(item => {
    if (item.unitAttributeName === PRODUCT_ATTRIBUTE_DIVISION && item.unitAttributeValue === FOOTWEAR_ATTRIBUTE_VALUE) {
      return product?.division === FOOTWEAR_DIVISION_VALUE;
    }
    if (item.unitAttributeName === PRODUCT_ATTRIBUTE_DIVISION && item.unitAttributeValue === APPAREL_ATTRIBUTE_VALUE) {
      return product?.division === APPAREL_DIVISION_VALUE;
    }
    if (
      item.unitAttributeName === PRODUCT_ATTRIBUTE_DIVISION &&
      item.unitAttributeValue === EQUIPMENT_ATTRIBUTE_VALUE
    ) {
      return product?.division === EQUIPMENT_DIVISION_VALUE;
    }
    if (item.unitAttributeName === PRODUCT_ATTRIBUTE_SILHOUETTE) {
      return item.unitAttributeValue === product?.silhouette?.code;
    }
    return item.unitAttributeValue === product?.silhouetteType?.code;
  });

export const mergeAllotmentsOrOptions = (list, product) =>
  list.reduce((acc, item) => {
    const total = acc;
    if (
      (item.unitAttributeName === PRODUCT_ATTRIBUTE_DIVISION &&
        ((item.unitAttributeValue === FOOTWEAR_ATTRIBUTE_VALUE && product?.division === FOOTWEAR_DIVISION_VALUE) ||
          (item.unitAttributeValue === APPAREL_ATTRIBUTE_VALUE && product?.division === APPAREL_DIVISION_VALUE) ||
          (item.unitAttributeValue === EQUIPMENT_ATTRIBUTE_VALUE && product?.division === EQUIPMENT_DIVISION_VALUE))) ||
      (item.unitAttributeName === PRODUCT_ATTRIBUTE_SILHOUETTE &&
        item.unitAttributeValue === product?.silhouette?.code) ||
      (item.unitAttributeName !== PRODUCT_ATTRIBUTE_DIVISION &&
        item.unitAttributeValue === product?.silhouetteType?.code)
    ) {
      total.push(item);
    }
    return total;
  }, []);
